<template>
  <div class="content-body">
    <LearnWhyTitle />
    <BrandValues />
    <ChoosingWecobi />
  </div>
</template>

<script>
import BrandValues from "./LearnWhyContent/BrandValues.vue";
import LearnWhyTitle from "./LearnWhyContent/LearnWhyTitle.vue";
import ChoosingWecobi from "./LearnWhyContent/ChoosingWecobi.vue";

export default {
  name: "LearnWhyContent",
  components: {
    LearnWhyTitle,
    BrandValues,
    ChoosingWecobi,
  },
};
</script>

<style scoped>
.content-body {
  padding: 29px 34px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media (max-width: 744px) {
  .content-body {
    padding: 21px 17px;
    gap: 16px;
  }
}
</style>
